<!-- 
BullentinView.vue
功能：佈告欄管理_編輯檢視
作者：i9400538 陳博承
完成：2021-07-07
-->
<template>
  <main>
    <tab-header-bullentin />
    <div class="tab-content">
      <div class="tab-pane active show">
        <!-- 資料呈現區塊 -->
        <div class="container" v-if="!editMode">
          <div class="row">
            <div class="col-12">
              <table id="searchBlock">
                <thead>
                  <tr>
                    <th>發佈日期</th>
                    <td width="25%" class="text-center">
                      <select
                        :id="`start-date-year-${colKey}`"
                        :data-vv-name="`start-date-year-${colKey}`"
                        v-validate="'required'"
                        data-vv-as="發佈日期(起)"
                        class="form-control form-control-inline"
                        v-model="start_date[0]"
                        :class="{ 'is-invalid': errors.has(`start-date-year-${colKey}`) }"
                      >
                        <option value>年份</option>
                        <option
                          v-for="(opt, y_opt_i) in yearOpt"
                          :key="`start-year-${y_opt_i}`"
                          :value="opt"
                        >{{opt - 1911}}年</option>
                      </select>

                      <span class="text">/</span>

                      <select
                        :id="`start-date-month-${colKey}`"
                        :data-vv-name="`start-date-month-${colKey}`"
                        v-validate="'required'"
                        data-vv-as="發佈日期(起)"
                        class="form-control form-control-inline"
                        v-model="start_date[1]"
                        :class="{ 'is-invalid': errors.has(`start-date-month-${colKey}`) }"
                      >
                        <option value>月份</option>
                        <option
                          v-for="(opt, m_opt_i) in monthOpt"
                          :key="`start-month-${m_opt_i}`"
                          :value="opt"
                        >{{opt}}月</option>
                      </select>
                    </td>
                    <td>~</td>
                    <td width="25%" class="text-center">
                      <select
                        :id="`end-date-year-${colKey}`"
                        :data-vv-name="`end-date-year-${colKey}`"
                        v-validate="'required'"
                        data-vv-as="發佈日期(訖)"
                        class="form-control form-control-inline"
                        v-model="end_date[0]"
                        :class="{ 'is-invalid': errors.has(`end-date-year-${colKey}`) }"
                      >
                        <option value>年份</option>
                        <option
                          v-for="(opt, y_opt_i) in yearOpt"
                          :key="`end-year-${y_opt_i}`"
                          :value="opt"
                        >{{opt - 1911}}年</option>
                      </select>

                      <span class="text">/</span>

                      <select
                        :id="`end-date-month-${colKey}`"
                        :data-vv-name="`end-date-month-${colKey}`"
                        v-validate="'required'"
                        data-vv-as="發佈日期(訖)"
                        class="form-control form-control-inline"
                        v-model="end_date[1]"
                        :class="{ 'is-invalid': errors.has(`end-date-month-${colKey}`) }"
                      >
                        <option value>月份</option>
                        <option
                          v-for="(opt, m_opt_i) in monthOpt"
                          :key="`end-month-${m_opt_i}`"
                          :value="opt"
                        >{{opt}}月</option>
                      </select>
                    </td>
                    <th style="padding-left: 30px;">發佈狀態</th>
                    <td class="text-center">
                      <select
                        :id="`status-${colKey}`"
                        :data-vv-name="`status-${colKey}`"
                        v-validate="'required'"
                        data-vv-as="發佈狀態"
                        class="form-control form-control-inline"
                        v-model="release_type"
                        :class="{ 'is-invalid': errors.has(`status-${colKey}`) }"
                      >
                        <option value="-1">全部</option>
                        <option value="0">待發佈</option>
                        <option value="1">發佈中</option>
                        <option value="2">已下架</option>
                      </select>
                    </td>
                    <td>
                      <a class="btn btn-primary" @click="doQuery('')">查詢</a>
                    </td>
                  </tr>
                </thead>
              </table>

              <!-- <br /> -->
              <span class="text-green" style="font-weight: bold;">明細列表：共{{bullentinList.length}}筆</span>
              <table
                id="bullentin_datatable"
                class="table datatable table-striped area-list-datatable mt-1"
              >
                <thead>
                  <tr>
                    <th
                      id="col_subject"
                      :class="'sorting ' + (order.fieldName == 'subject' ? (order.asc ? 'sorting_asc' : 'sorting_desc') : '')"
                      @click="processList('subject')"
                    >主旨</th>
                    <th
                      id="col_start_date"
                      :class="'sorting ' + (order.fieldName == 'star_date' ? (order.asc ? 'sorting_asc' : 'sorting_desc') : '')"
                      @click="processList('star_date')"
                      class="text-center"
                    >發佈日期</th>
                    <th
                      id="col_end_date"
                      :class="'sorting ' + (order.fieldName == 'end_date' ? (order.asc ? 'sorting_asc' : 'sorting_desc') : '')"
                      @click="processList('end_date')"
                      class="text-center"
                    >下架日期</th>
                    <th id="col_approval_status" 
                        class="text-center"
                        :class="'sorting ' + (order.fieldName == 'approval_status' ? (order.asc ? 'sorting_asc' : 'sorting_desc') : '')"
                        @click="processList('approval_status')"
                    >審核進度</th>
                    <th id="col_release_status" 
                        ref="lastCol" 
                        class="text-center"
                        :class="'sorting ' + (order.fieldName == 'release_status' ? (order.asc ? 'sorting_asc' : 'sorting_desc') : '')"
                        @click="processList('release_status')"
                    >發佈狀態</th>
                  </tr>
                </thead>
                <tbody id="bullentin-view" v-if="bullentinList.length">
                  <tr
                    v-for="(item, index) in bullentinList"
                    :key="`td-bullentinList-${index}-${item.ser_no}`"
                  >
                    <td width="30%">
                      <a
                          href="javascript:void(0);"
                          class="text-green text-underline pointer-cursor font-weight-bold"
                          @click="doEdit(item, true)"
                        >
                          {{item.subject}}
                      </a>
                    </td>
                    <td class="text-center">
                      <div class="date">{{item.star_date | dateFormat}}</div>
                    </td>
                    <td class="text-center">
                      <div class="date">{{item.end_date | dateFormat}}</div>
                    </td>
                    <td :width="iPadWidth" class="text-center ">
                      <span
                          v-if="item.approval_status == 0" class="text-gray font-weight-bold"
                        >
                          已審核
                      </span>
                      <span
                          v-else-if="item.approval_status == 1 && item.upd_id == $store.state.userInfo.id"
                          class="text-green font-weight-bold"
                        >
                          待審核
                      </span>
                      <a
                          v-else
                          href="javascript:void(0);"
                          class="text-green text-underline pointer-cursor font-weight-bold"
                          @click="doEdit(item, false)"
                        >
                          待審核
                      </a>
                      <!-- <a class="text-green text-underline pointer-cursor" @click="doEdit(item)">{{item.approval_status || ''}}</a> -->
                    </td>
                     <td class="text-center text-gray font-weight-bold">{{formatReleaseStatus(item.star_date, item.end_date)}}</td>
                  </tr>
                </tbody>
                <tbody v-else>
                  <tr>
                    <td colspan="5" class="empty">
                      <h3 class="text-center py-5">無任何資料</h3>
                    </td>
                    <td v-show="false"></td>
                    <td v-show="false"></td>
                    <td v-show="false"></td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>

        <!-- 資料編輯區塊 -->
        <bullentin-content
          :isEdit="editMode"
          :bullentinInfo="editData"
          :editFromSubject="editFromSubject"
          @doCancelEdit="doCancelEdit"
          @doQuery="doQuery"
        />
      </div>
    </div>

    <!-- 打開遮罩 -->
    <mxMask :open="mxMaskOpen" />
  </main>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import { commonMixin } from "@/mixins/common";
import { setTimeout } from "timers";

//component
import TabHeaderBullentin from "@/desktop/components/backend/TabHeaderBullentin";
import BullentinContent from "@/desktop/views/backend/BullentinContent";
import mxMask from "@/desktop/components/mxMask";
//service
import { callBullentinProcess } from "@/service";
//parameter
const is_iPad = navigator.userAgent.match(/iPad/i) != null; // 確認裝置是否為 iPad

export default {
  name: "BullentinView",
  mixins: [commonMixin],
  components: {
    TabHeaderBullentin,
    BullentinContent,
    mxMask
  },
  data() {
    return {
      today: window.moment(),
      mxMaskOpen: false,
      start_date: ["", ""],
      end_date: ["", ""],
      colKey: "search",
      yearOpt: [],
      monthOpt: [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12],
      bullentinList: [], //顯示資料
      // activeList: [], //發佈中資料
      // unActiveList: [], //已下架資料
      order: {
        fieldName: "subject",
        asc: true
      },
      iPadWidth: 364,
      editData: {},
      editMode: false,
      release_type: '-1', //發佈狀態,
      editFromSubject: true
    };
  },
  watch: {
  },
  computed: {
    ...mapGetters(["BaseUrl", "UserInfo"])
  },
  methods: {
    ...mapActions(["setPageLock"]),
    //欄位排序
    processList(fieldName) {
      let order = this.order;
      if (order.fieldName == fieldName) {
        order.asc = !order.asc;
      } else {
        order.fieldName = fieldName;
        order.asc = true;
      }

      //data排序
      let sortOrder = -1;
      if (order.asc) {
        sortOrder = 1;
      }

      switch (fieldName) {
        case "star_date":
        case "end_date":
          setTimeout(() => {
            this.bullentinList.sort(this.dateCompareFun(sortOrder, fieldName));
            this.registerHanlink(); // 難字顯示
          }, 20);
          break;
        default:
          setTimeout(() => {
            this.bullentinList.sort(this.sortCompareFun(sortOrder, fieldName));
            this.registerHanlink(); // 難字顯示
          }, 20);
      }
    },
    sortCompareFun(sortOrder, property) {
      return function(a, b) {
        let result =
          a[property] < b[property] ? -1 : a[property] > b[property] ? 1 : 0;
        return result * sortOrder;
      };
    },
    //日期排序
    dateCompareFun(sortOrder, property) {
      return function(a, b) {
        let date_a = new Date(
          a[property] ? a[property] : "1880-01-01"
        ).getTime();
        let date_b = new Date(
          b[property] ? b[property] : "1880-01-01"
        ).getTime();
        let result = date_a < date_b ? -1 : 1;
        return result * sortOrder;
      };
    },
    //查詢
    doQuery(startDateEdit) {
      //檢核
      this.$validator.validateAll().then(el => {
        if (!el) {
          let errMsg = [];
          for (let i = 0; i < this.errors.items.length; i++) {
            errMsg.push(this.errors.items[i].msg);
          }
          let showErrMsg = [...new Set(errMsg)];
          showErrMsg.forEach(s => {
            this.$toast.info({ title: s }); //印出檢核後的錯誤訊息
          });
          return;
        }

        this.$validator.reset();
        let startDate = ""; //查詢的起始日
        let endDate = ""; //查詢的結束日
        let lastDay = ""; //每月最後一天
        if (startDateEdit) {
          //編輯成功後觸發重新查詢
          this.editMode = false;
          let yearmonth = startDateEdit.substring(0, startDateEdit.length - 2);
          startDate = yearmonth + "01";
          lastDay = new Date(
            startDateEdit.substring(0, 4),
            startDateEdit.substring(5, 7),
            0
          ).getDate();
          endDate = yearmonth + lastDay;
          this.initDate(startDateEdit);
        } else {
          let startMonth =
            this.start_date[1].toString().length == 1
              ? "0" + this.start_date[1].toString()
              : this.start_date[1].toString();
          let endMonth =
            this.end_date[1].toString().length == 1
              ? "0" + this.end_date[1].toString()
              : this.end_date[1].toString();

          let start = this.start_date[0] + startMonth;
          let end = this.end_date[0] + endMonth;
          if (parseInt(start) > parseInt(end)) {
            this.setToastMsg("發佈日期起始日不可大於結束日");
            return;
          }

          lastDay = new Date(
            this.end_date[0],
            parseInt(this.end_date[1]),
            0
          ).getDate();
          startDate = `${this.start_date[0]}-${startMonth}-01`;
          endDate = `${this.end_date[0]}-${endMonth}-${lastDay}`;
        }

        let queryData = {
          input_start_date: startDate,
          input_end_date: endDate
        };

        this.mxMaskOpen = true;
        callBullentinProcess(this.UserInfo.id, queryData, "1", "").then(
          result => {
            this.mxMaskOpen = false;
            if (result.header && result.header.status == "200") {
              this.bullentinList = result.body.result
              this.setReleaseStatus()
              if(this.release_type != '-1'){
                  this.bullentinList = this.bullentinList.filter(item => item.release_status == this.release_type)
              }            
            } else {
              this.setToastMsg(result.header.message);
            }
          }
        );
      });
    },
    //編輯資料
    doEdit(item, isFromSubject) {
      this.editData = item;
      this.editMode = true;
      this.editFromSubject = isFromSubject;
    },
    doCancelEdit() {
      this.editMode = false;
    },
    formatReleaseStatus(s_date, e_date){
        const [sy, sm, sd] = s_date.split('-').map(Number);
        const startDate = new Date(sy, sm - 1, sd);

        let endDate = null;
        if (e_date) {
          const [ey, em, ed] = e_date.split('-').map(Number);
          endDate = new Date(ey, em - 1, ed);
        }

        const currentDate = new Date();
        currentDate.setHours(0, 0, 0, 0);
        startDate.setHours(0, 0, 0, 0);
        if (endDate) endDate.setHours(0, 0, 0, 0);

        if (currentDate < startDate) {
          return '待發佈';
        }

        if (endDate && currentDate > endDate) {
          return '已下架';
        }

        return '發佈中';
    },
    setReleaseStatus(){
      this.bullentinList.forEach(item => {
        const statusText = this.formatReleaseStatus(item.star_date, item.end_date);
        let statusCode = '';

        if (statusText === '待發佈') {
          statusCode = '0';
        } else if (statusText === '發佈中') {
          statusCode = '1';
        } else if (statusText === '已下架') {
          statusCode = '2';
        }

        this.$set(item, 'release_status', statusCode);
      });
    },
    //欄位寬度初始化
    initColWidth() {
      if (!is_iPad) {
        this.iPadWidth = this.$refs.lastCol.clientWidth - 15;
      } else {
        this.iPadWidth = this.$refs.lastCol.clientWidth;
      }
    },
    //查詢條件初始化
    initDate(startDateEdit) {
      let year = "";
      let month = "";
      if (startDateEdit) {
        year = startDateEdit.substring(0, 4);
        month = parseInt(startDateEdit.substring(5, 7));
      } else {
        year = this.today.year();
        month = this.today.month() + 1;
      }
      this.start_date[0] = year;
      this.start_date[1] = month;
      this.end_date[0] = year;
      this.end_date[1] = month;
    },
    //初始化 (若由新增畫面進入，觸發查詢)
    init() {
      let start = this.$route.params.start_date || "";
      if (start) {
        let start_Arr = start.split("-");
        this.start_date[0] = start_Arr[0]; //年
        this.end_date[0] = start_Arr[0]; //年
        if (parseInt(start_Arr[1]) > 9) {
          this.start_date[1] = start_Arr[1]; //月
          this.end_date[1] = start_Arr[1]; //月
        } else {
          this.start_date[1] = start_Arr[1].replace("0", ""); //月 (去除0)
          this.end_date[1] = start_Arr[1].replace("0", ""); //月 (去除0)
        }
      }
      setTimeout(() => {
        this.doQuery("");
      }, 10);
    }
  },
  beforeMount() {
    //檢查使用者是否為通路科/數支科的人
    //檢查使用者是否有後台管理權限
    let divNo = this.UserInfo.divNo;
    let functionId = this.UserInfo.functionId || [];
    if (
      divNo !== "9400400" &&
      divNo !== "9N00200" &&
      !functionId.includes("4")
    ) {
      this.$router.push({ path: "/" });
    }
  },
  mounted() {
    let start = window.moment().year();
    for (let s = start - 2 ; s <= start + 2 ; s++) {
      this.yearOpt.push(s);
    }
    this.initColWidth();
    this.initDate("");
    this.init();
  }
};
</script>

<style lang="scss" scoped>
.text-center {
  text-align: center;
}
.table.datatable {
  tbody {
    tr > td {
      &:first-child {
        padding-top: 10px;
      }
    }
  }
}
</style>
